export { default } from "-!./Dashboard.ts?vue&type=script&lang=ts&external"; export * from "-!./Dashboard.ts?vue&type=script&lang=ts&external"